import { useIsStudentDisqualified } from 'pages/AffordaHousehold/AffordaHousehold.FullTimeStudent.hooks';
import useBaseURL from 'hooks/useBaseURL';
import PATHS from 'constants/paths';
import { useSectionsProgressContext } from 'contexts/SectionsProgressContext';
import { HOUSEHOLD_PATHS } from 'constants/paths';

export const useGoBack = ({ history }) => {
  const baseURL = useBaseURL();
  const isStudentDisqualified = useIsStudentDisqualified();
  const { previousURL } = useSectionsProgressContext();

  const to = previousURL ? previousURL : `${baseURL}/${PATHS.DASHBOARD}`;
  const isOnDashboard =
    history.location.pathname === `${baseURL}/${PATHS.DASHBOARD}`;
  const isInviteMembersScreen = history.location.pathname.endsWith(
    HOUSEHOLD_PATHS.INVITE,
  );

  const isHidden =
    isStudentDisqualified || isOnDashboard || isInviteMembersScreen;

  return {
    onClick: () => history.replace(to),
    sx: {
      visibility: isHidden ? 'hidden' : 'visible',
    },
  };
};
